module.exports = __webpack_public_path__ + "img/image-prev-white.2806bbf8.png";